import { j as s } from "./jsx-runtime-DmTjM30f.mjs";
import * as l from "react";
import { forwardRef as p, useRef as x, useState as N, useImperativeHandle as D, useEffect as F } from "react";
import { c as z } from "./index.js-Cr0Rsuyz.mjs";
import { e as P } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as w } from "./tw-cn-mXgPecoF.mjs";
import { c as b } from "./index-BpNK5r1N.mjs";
function B(a, n) {
  return /* @__PURE__ */ l.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: n
  }, a), /* @__PURE__ */ l.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.028 6.681a1.67 1.67 0 0 1 2.362 2.363l-9.06 9.06a1.5 1.5 0 0 1-2.121 0l-5.354-5.353a1.492 1.492 0 1 1 2.11-2.11l3.91 3.91a.2.2 0 0 0 .283 0z",
    clipRule: "evenodd"
  }));
}
var H = z(/* @__PURE__ */ p(B));
function K(a, n) {
  return /* @__PURE__ */ l.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: n
  }, a), /* @__PURE__ */ l.createElement("path", {
    fill: "currentColor",
    d: "M4 12.11c0-.89.72-1.61 1.61-1.61h12.78a1.61 1.61 0 1 1 0 3.219H5.61A1.61 1.61 0 0 1 4 12.109"
  }));
}
var O = z(/* @__PURE__ */ p(K));
const V = b(["relative inline-block"], {
  variants: {
    size: {
      medium: "size-24",
      small: "size-20"
    },
    pcSize: {
      medium: "pc:size-24",
      small: "pc:size-20"
    }
  }
}), A = b(
  [
    "focus:ring-green-500 peer size-full appearance-none rounded-4 cursor-pointer",
    "bg-static-white border border-line-neutral-medium",
    "checked:border-none disabled:cursor-not-allowed"
  ],
  {
    variants: {
      state: {
        checked: [
          "checked:bg-static-black checked:hover-never:bg-interaction-neutral-presshover-strong1 checked:active:bg-interaction-neutral-presshover-strong1",
          "disabled:bg-interaction-neutral-disable-main disabled:hover-never:bg-interaction-neutral-disable-main disabled:active:bg-interaction-neutral-disable-main"
        ],
        empty: [
          "checked:bg-static-black hover-never:bg-interaction-neutral-presshover-weak1 checked:active:bg-interaction-neutral-presshover-weak1",
          "disabled:bg-fill-neutral-weak disabled:hover:bg-fill-neutral-weak disabled:border-interaction-neutral-disable-main"
        ],
        indeterminate: [
          "bg-static-black border-none hover-never:bg-interaction-neutral-presshover-strong1 active:bg-interaction-neutral-presshover-strong1",
          "disabled:bg-interaction-neutral-disable-main disabled:hover-never:bg-interaction-neutral-disable-main disabled:active:bg-interaction-neutral-disable-main"
        ]
      }
    },
    defaultVariants: {
      state: "empty"
    }
  }
), y = b(
  ["pointer-events-none absolute text-static-white", "left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"],
  {
    variants: {
      state: {
        default: "opacity-0 peer-checked:opacity-100",
        indeterminate: ""
      },
      size: {
        medium: "size-20",
        small: "size-16"
      },
      pcSize: {
        medium: "pc:size-20",
        small: "pc:size-16"
      }
    },
    defaultVariants: {
      state: "default"
    }
  }
), e = {
  Checked: "checked",
  Indeterminate: "indeterminate",
  Empty: "empty"
}, M = p((a, n) => {
  const {
    className: C,
    style: E,
    checked: o,
    indeterminate: d,
    disabled: h,
    type: v = "checkbox",
    size: S,
    onChange: m,
    ...I
  } = a, r = x(null), f = x(null), [i, c] = N(() => d ? e.Indeterminate : o ? e.Checked : e.Empty), u = P({
    property: S,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: {
      mobile: "small",
      pc: "medium"
    }
  }), g = V({ ...u }), R = A({ state: i });
  D(n, () => ({
    focus: (t) => {
      var k;
      (k = r.current) == null || k.focus(t);
    },
    blur: () => {
      var t;
      (t = r.current) == null || t.blur();
    },
    input: r.current,
    nativeElement: f.current
  }));
  const j = (t) => {
    h || (c(t.target.checked ? e.Checked : e.Empty), m == null || m({
      target: {
        ...a,
        type: v,
        checked: t.target.checked
      },
      stopPropagation() {
        t.stopPropagation();
      },
      preventDefault() {
        t.preventDefault();
      },
      nativeEvent: t.nativeEvent
    }));
  };
  return F(() => {
    c(d ? e.Indeterminate : o ? e.Checked : e.Empty);
  }, [o, d]), /* @__PURE__ */ s.jsxs("span", { className: w(g, C), ref: f, style: E, children: [
    /* @__PURE__ */ s.jsx(
      "input",
      {
        ...I,
        checked: i === e.Checked,
        className: w(R, g),
        disabled: h,
        onChange: j,
        ref: r,
        type: v
      }
    ),
    i === e.Checked && /* @__PURE__ */ s.jsx(H, { className: y({ ...u }) }),
    i === e.Indeterminate && /* @__PURE__ */ s.jsx(O, { className: y({ ...u, state: "indeterminate" }) })
  ] });
});
M.displayName = "NDS.Checkbox";
export {
  M as C
};
